import React from 'react';
import {Card} from 'antd';
import AIProcessorInfoHeader from './AIProcessorInfoHeader';
import PackDataExpandedRow from './PackDataExpandedRow';
import PipelineToolbar from './PipelineToolbar';
import PipelineStageSelector from './PipelineStageSelector';
import usePackPipeline from './usePackPipeline';


const PackPipelineDetail = ({ service_item_id }: { service_item_id: number }) => {
    const {
        current, setCurrent,
        isEditing, setIsEditing,
        compareMode, setCompareMode,
        setComparePipelineID,
        currentPackData, comparePackData,
        pipelineOptions, displayPipelineID, displayComparePipelineID,
        dataPipeline, dataComparePipeline,
        currentAIProcessorResponse, compareAIProcessorResponse, genUIData,
        handlePipelineChange, triggerPackData,
        triggerAIProcessor, retriggerAIProcessor, toggleAppliedStatus,
    } = usePackPipeline(service_item_id);

    return (
        <>
            <PipelineToolbar
                pipelineOptions={pipelineOptions}
                displayPipelineID={displayPipelineID}
                displayComparePipelineID={displayComparePipelineID}
                compareMode={compareMode}
                dataPipeline={dataPipeline}
                handlePipelineChange={handlePipelineChange}
                setCompareMode={setCompareMode}
                setComparePipelineID={setComparePipelineID}
                toggleAppliedStatus={toggleAppliedStatus}
                triggerAIProcessor={triggerAIProcessor}
                retriggerAIProcessor={retriggerAIProcessor}
            />
            <PipelineStageSelector
                current={current}
                onChange={(value) => setCurrent(value as 0|1|2)}
                dataPipeline={dataPipeline}
            />

            <Card>
                {compareMode ? (
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', marginBottom: '16px' }}>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                                Pipeline {dataPipeline?.version || 'Current'}
                            </div>
                            <AIProcessorInfoHeader
                                aiProcessorResponse={currentAIProcessorResponse}
                                pipelineData={dataPipeline}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                                Pipeline {dataComparePipeline?.version || 'Compare'}
                            </div>
                            <AIProcessorInfoHeader
                                aiProcessorResponse={compareAIProcessorResponse}
                                pipelineData={dataComparePipeline}
                            />
                        </div>
                    </div>
                ) : (
                    <AIProcessorInfoHeader
                        aiProcessorResponse={currentAIProcessorResponse}
                        pipelineData={dataPipeline}
                    />
                )}

                <PackDataExpandedRow
                    initialValue={currentPackData?.data}
                    compareValue={comparePackData?.data}
                    isCompareMode={compareMode}
                    dataPipeline={dataPipeline}
                    dataComparePipeline={dataComparePipeline}
                    isEditing={isEditing}
                    onStartEditing={() => setIsEditing(true)}
                    onSubmitEdit={(editedJson) => {
                        triggerPackData(editedJson);
                        setIsEditing(false);
                    }}
                    onCancelEdit={() => setIsEditing(false)}
                    genUIData={genUIData}
                />
            </Card>
        </>
    );
};

export default PackPipelineDetail;
